import React from "react";

const OPTIONS = ["Non Smoker", "Daily", "Socially", "Vapour Only", "Ex-smoker"];

const SmokerStatusSection = ({ smokerStatus, onSmokerStatusChange }) => {
  const isNotCarriedOut =
    String(smokerStatus || "")
      .trim()
      .toLowerCase() === "n/a";

  const handleNotCarriedOutToggle = (e) => {
    onSmokerStatusChange(e.target.checked ? "n/a" : "");
  };

  return (
    <div className="px-4 mt-6">
      <div className="rounded-2xl border border-sky-200 bg-white shadow-sm overflow-hidden">
        <div className="px-4 py-3 border-b border-sky-100 bg-sky-50 flex items-center justify-between gap-3">
          <h2 className="font-fatfrank text-lg md:text-xl text-sas-primary">
            Smoker Status
          </h2>
          <label className="inline-flex items-center gap-2 cursor-pointer select-none">
            <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-sas-primary">
              Not carried out
            </span>
            <span className="relative inline-flex h-5 w-10 items-center">
              <input
                type="checkbox"
                className="peer sr-only"
                checked={isNotCarriedOut}
                onChange={handleNotCarriedOutToggle}
              />
              <span className="absolute inset-0 rounded-full bg-slate-300 transition peer-checked:bg-sas-primary"></span>
              <span className="absolute left-0.5 top-0.5 h-4 w-4 rounded-full bg-white transition peer-checked:translate-x-5"></span>
            </span>
          </label>
        </div>
        <div className="p-4 grid grid-cols-2 md:grid-cols-5 gap-3">
          {OPTIONS.map((option) => {
            const id = option.toLowerCase().replace(/\s+/g, "-");
            const selected = smokerStatus === option;
            return (
              <label
                key={option}
                htmlFor={id}
                className={`rounded-xl border px-3 py-2 flex items-center gap-2 transition ${
                  selected
                    ? "border-sas-primary bg-sas-primary/10"
                    : "border-slate-200"
                } ${
                  isNotCarriedOut
                    ? "cursor-not-allowed opacity-60"
                    : "cursor-pointer hover:border-sas-primary/50"
                }`}
              >
                <input
                  type="radio"
                  name="smokerStatus"
                  id={id}
                  value={option}
                  checked={selected}
                  onChange={(e) => onSmokerStatusChange(e.target.value)}
                  className="h-4 w-4 border-sas-primary text-sas-primary focus:ring-sas-primary"
                  disabled={isNotCarriedOut}
                />
                <span className="text-sm font-semibold text-sas-primary-dark">
                  {option}
                </span>
              </label>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SmokerStatusSection;
